import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-8 sm:py-32">
      <p className="tag-mono mb-4 text-[#E4C5B3]">Erreur 404</p>
      <h1 className="font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
        Cette page n'existe pas ou plus
      </h1>
      <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-zinc-400">
        La référence que vous cherchez a peut-être changé d'adresse. Repartez de l'accueil ou explorez le catalogue.
      </p>
      <div className="mt-9 flex flex-wrap justify-center gap-4">
        <a href="/" data-testid="notfound-home-cta" className="btn-primary">
          Retour à l'accueil <ArrowRight size={16} aria-hidden="true" />
        </a>
        <a href="/produits/" data-testid="notfound-produits-cta" className="btn-ghost">
          Voir les produits
        </a>
      </div>
    </div>
  );
}
